import styled from "styled-components";

export  const ContainerCategoria = styled.div`
  background-color: #D9D9D9 ;
    width: max-content;
    padding: 5px;
    border-radius: 25px;
    display: flex;
    align-items: center;
    padding-left: 12px;
    padding-right: 12px;
    margin-top: 20px;
    cursor: pointer;
`;

export const Capacidade = styled.span`
  font-weight: bold;
    font-size: 12px;
`;
export const TituloCategoria = styled.span`
    color: #083DF8;
    font-size: 22px;
    padding-right: 12px;
    font-weight: bolder;
    margin-left: 10px;
`;
